import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Section, Title } from "../../components/Common/PageElement";
import { LoadContext } from "../../context/LoadContext";
import { SERVER_URL,TRACK_API } from "../../services/Config";
import ScaleSlider from "./ScaleSlider/ScaleSlider";
import { ApplicationRow } from "./StyledApplication";
import Tracks from "./Tracks/Tracks";
import useWindowSize from "./Tracks/Service/useWindowSize";
import Toolbar from "./Toolbar";

import LoadingOverlay from 'react-loading-overlay';

import BounceLoader from 'react-spinners/BounceLoader';
import { ReactNotifications, Store } from 'react-notifications-component';

const taxonomy_level = [
    { value: "Domain", name: "Domain" },
    { value: "Phylum", name: "Phylum" },
    { value: "Class", name: "Class" },
    { value: "Order", name: "Order" },
    { value: "Family", name: "Family" },
    { value: "Genus", name: "Genus" },
    // { value: "Species", name: "Species" }
    // { value: "genome", name: "Genome" },
];

const Application = () => {
    var urlToken = window.location.href
        .split("#/?")[1]
        .split("&")[0]
        .slice("id=".length);

    const { setLoad } = useContext(LoadContext);
    // Data
    const [trackData, setTrackData] = useState(null);
    const [metaData, setMetaData] = useState(null);
    const [recordType, setRecordType,] = useState(null);
    const [curDatabase,setCurDatabase] = useState('');


    // Forms
    const [taxonomy, setTaxonomy] = useState(taxonomy_level[3]["value"]);
    const [filterGene, setFilterGene] = useState("");
    const [meta, setMeta] = useState(null);
    // Scale
    const [scale, setScale] = useState(30);
    const [width, height] = useWindowSize();

    //loading spinner
    const [isLoadActive, setIsLoadActive] = useState(false)

    // current centered gene:
    const [curCenterGene, setCurCenterGene] = useState("")

    // command for tracks
    const [command, setCommand] = useState({})

    // mode can be Scroll or Drag, 0 for Scroll, 1 for Drag
    const [mode,setMode] = useState(0)

    const [relocate,setRelocate] = useState(0)

    const [zoomLevel, setZoomLevel] = useState(0.5)
    const [widthLevel, setWidthLevel] = useState(1.0)


    LoadingOverlay.propTypes = void 0

    const handleSearch = (val) => {
        setFilterGene(val);
    };

    const handleTaxonomy = (val) => {
        setTaxonomy(val);
    };

    const handleMeta = (val) => {
        setMeta(val);
    };

    const handleZoom = (command) =>{
        if(command === 'ZoomOut'){
            let curZoomLevel = zoomLevel - 0.1
            if(curZoomLevel > 0){

                setZoomLevel(prevState => {return curZoomLevel})
            }

        }
        // zoom in
        else{
            setZoomLevel(prevState => {return prevState + 0.1})
        }
    }

    const handleChangeWidth = (command) =>{
        let interval = 1.0
        if(command === 'Decrease'){
            let curWidthLevel = widthLevel - interval
            if(curWidthLevel >= interval){

                setWidthLevel(prevState => {return curWidthLevel})
            }

        }
        // increase
        else{
            setWidthLevel(prevState => {return prevState + interval})
        }
    }

    const handleRelocate =() => {
        setRelocate(prevState => {return prevState + 1})
    }

    const handleSwitchMode =() => {
        if(mode === 0){
            setMode(1)
        }
        else{
            setMode(0)
        }
    }

    useEffect(() => {
        axios
            .get(SERVER_URL + TRACK_API, {
                params: {
                    token: urlToken,
                },
            })
            .then((response) => {
                setLoad(false);

                // console.log(response.data.metas)
                // console.log(response.data.tracks)
                // console.log(response.data.record_type)
                // console.log(response.data.database)

                // currently type can be upload or annotree_search or csv_parse or null
                setTrackData(response.data.tracks);


                setMetaData(response.data.metas);
                setRecordType(response.data.record_type)

                setCurDatabase(response.data.database)


                var metaValueLst = response.data.metas.map((item)=>{
                    return item["value"]

                })


                // console.log(metaValueLst)
                var hideMeta = void 0
                var result_meta = void 0
                let curType = response.data.record_type

                // if(curType === 'annotree_search' ){
                //     hideMeta = ['product','protein','gene','id'];
                //     result_meta = metaValueLst.filter((m)=>{
                //         if(hideMeta.indexOf(m) > -1 ){
                //             // console.log(m)
                //             return false
                //         }
                //         return true
                //     })
                // }
                // else{
                //     hideMeta = ['id','protein'];
                //     result_meta = metaValueLst.filter((m)=>{
                //         if(hideMeta.indexOf(m) > -1 ){
                //             // console.log(m)
                //             return false
                //         }
                //         return true
                //     })
                // }

                // default is kegg_id
                // setMeta(metaValueLst.indexOf('kegg_id') === -1?metaValueLst[0]:'kegg_id')

                // if KEGG in metas, then KEGG will be the default one
                setMeta(metaValueLst.indexOf('KEGG') === -1?metaValueLst[0]:'KEGG')


                // setMeta(result_meta.indexOf('kegg_id') === -1?result_meta[0]:'kegg_id')



            })
            .catch((e) => {
                // console.log(e)
                setLoad(false);
                alert("Application Error");
            });
    }, []);

    const centerProtein = ({ isLoad,center}) => {

        // add loading
        setIsLoadActive(isLoad)


    };



    if (trackData && metaData && meta) {
        const metaDataSelected = metaData.find((x) => x.value === meta).data;
        const results = !filterGene
            ? ""
            : metaDataSelected.filter((gene) =>
                  gene.label.toLowerCase().includes(filterGene.toLowerCase())
              );
        const exact = metaDataSelected.filter(function (gene) {
            if (!filterGene) {
                return "";
            } else {
                return gene.label.toLowerCase() === filterGene.toLowerCase();
            }
        });
        var filter;
        if (exact.length !== 0) {
            filter = exact;
        } else {
            filter = results;
        }

        return (
            <Section id="application">
                <Container fluid>
                    <ApplicationRow>
                        <Col>
                            <Toolbar
                                metaData={metaData}
                                meta={meta}
                                filterGene={filterGene}
                                handleSearch={handleSearch}
                                taxonomyLevel={taxonomy_level}
                                taxonomy={taxonomy}
                                handleTaxonomy={handleTaxonomy}
                                handleMeta={handleMeta}
                                token={urlToken}
                                recordType={recordType}
                                relocate={handleRelocate}
                                switchMode={handleSwitchMode}
                                zoom={handleZoom}
                                changeWidth={handleChangeWidth}
                                trackLength={trackData.length}
                                scale={scale}

                            />
                        </Col>
                    </ApplicationRow>
                    {/* <ApplicationRow>
                        <ScaleSlider onChange={(event, val) => setScale(val)} />
                    </ApplicationRow>*/}

                    <LoadingOverlay
                        active={isLoadActive}
                        spinner
                        text='Center Clustering......'
                    >

                        <ApplicationRow>

                            <Col>
                                <Tracks
                                    data={trackData}
                                    meta={metaData.find((x) => x.value === meta)}
                                    recordType={recordType}
                                    centerCallback={centerProtein}
                                    filter={filter}
                                    scale={scale}
                                    localCenterGene={curCenterGene}
                                    trackTaxonomy={taxonomy}
                                    database={curDatabase}
                                    token={urlToken}
                                    // handleSearch={handleSearch}
                                    relocate={relocate}
                                    visionMode={mode}
                                    zoomLevel={zoomLevel}
                                    widthLevel={widthLevel}
                                    // command={}
                                />
                            </Col>
                        </ApplicationRow>
                    </LoadingOverlay>
                </Container>
            </Section>
        );
    } else {
        return (
            <Section>
                <Container>
                    <Row>
                        <Col>
                            <Title>Loading...</Title>
                        </Col>
                    </Row>
                </Container>
            </Section>
        );
    }
};

export default Application;
